import React, { useEffect, useRef, useState } from 'react';
import { useThrottle, useUpdateEffect } from 'ahooks';
import { useSearchBox } from 'react-instantsearch-hooks-web';

export const SearchBox = (props) => {
  const searchBoxRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState('');
  const throttledValue = useThrottle(searchQuery, { wait: 500 });
  const { query, refine, clear, isSearchStalled } = useSearchBox(props);

  const handleQueryUpdate = (ev) => {
    setSearchQuery(ev.currentTarget.value);
  };

  useEffect(() => {
    if (searchBoxRef.current) {
      // searchBoxRef.current.focus();
    }
  }, [searchBoxRef.current]);

  useUpdateEffect(() => {
    refine(searchQuery);
  }, [throttledValue]);

  const handleQueryReset = () => {
    setSearchQuery('');
    clear();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `/search?q=${searchQuery}`;
  };

  return (
    <form className="SearchBox" onSubmit={handleSubmit}>
      <label>
        <span className="screen-reader-text">Search</span>
        <input type="text" ref={searchBoxRef} value={searchQuery} placeholder="Search the site" onChange={handleQueryUpdate} />
      </label>
      {searchQuery && (
        <div className="options">
          <button type="button" onClick={handleQueryReset}>
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#close"></use>
            </svg>
          </button>
          <button type="submit">
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#search"></use>
            </svg>
          </button>
        </div>
      )}
    </form>
  );
};
